<template>

  <gnetFormMask v-on:click="toggleSection($event)" v-bind:sections="sections" v-on:change="setField($event)">

  </gnetFormMask>

</template>
    
<script>
import gnetFormMask from '../components/formmask.vue'

export default {
  name: 'recordfields',
  components: {
      gnetFormMask
  },
  props: {
    title: String,
    hspace: String,
    disabled: Boolean,
    wmode: Boolean,
    dati: Object,
    newcustomer: Boolean,
    readonly: Boolean
  },
  data() {
    return {
        page:0,
        sections: [],
    }
  },
  computed: {
  },
  async created() {

  },
  mounted: function() {
      var itab=0;
      var sectionFields=[];
      sectionFields.push( { id:itab++, value:this.dati.Name, title:'Ragione Sociale', name:'dati.Name', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.Codice_Subentro__c, title:'Subentra a codice', name:'dati.Codice_Subentro__c', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.Insegna__c, title:'Insegna', name:'dati.Insegna__c', type:'text', placeholder:'', tabindex:itab++, disabled: this.readonly } );
      this.sections.push( { order: 1, title: 'Dati principali', opened: true, fields: sectionFields  });
      sectionFields=[];
      sectionFields.push( { id:itab++, value:this.dati.BillingStreet, title:'Indirizzo', name:'dati.BillingStreet', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.BillingCity, title:'Città', name:'dati.BillingCity', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.BillingPostalcode, title:'Cap', name:'dati.BillingPostalcode', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.BillingState, title:'Provincia', name:'dati.BillingState', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      this.sections.push( { order: 2, title: 'Sede Legale', opened: true, fields: sectionFields  });
      sectionFields=[];
      sectionFields.push( { id:itab++, value:this.dati.Referente__c, title:'Referente', name:'dati.Referente__c', type:'text', placeholder:'', tabindex:itab++, disabled: this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.Phone, title:'Telefono/Cellulare', name:'dati.Phone', type:'text', placeholder:'', tabindex:itab++, disabled: this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.Fax, title:'Fax', name:'dati.Fax', type:'text', placeholder:'', tabindex:itab++, disabled: this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.Email__c, title:'E-Mail', name:'dati.Email__c', type:'text', placeholder:'', tabindex:itab++, disabled: this.readonly } );
      this.sections.push( { order: 3, title: 'Contatto', opened: true, fields: sectionFields  });
      sectionFields=[];
      sectionFields.push( { id:itab++, value:this.dati.P_Iva__c, title:'Partita Iva', name:'dati.P_Iva__c', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.IBAN__c, title:'IBAN', name:'dati.IBAN__c', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.Codice_Fatturazione_Elettronica__c, title:'Codice destinatario SDI', name:'dati.Codice_Fatturazione_Elettronica__c', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.PEC__c, title:'Pec', name:'dati.PEC__c', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      this.sections.push( { order: 4, title: 'Dati di fatturazione', opened: true, fields: sectionFields  });
      sectionFields=[];
      sectionFields.push( { id:itab++, value:this.dati.Spedire__c, title:'Destinazione differente', name:'dati.Spedire__c', type:'picklist', options:[ {label:'Si', value:'Si'},{label:'No', value:'No'} ],placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.tappo1, title:'Insegna', name:'Name', type:'null', placeholder:'', tabindex:itab++, disabled: false} );
      sectionFields.push( { id:itab++, value:this.dati.ShippingStreet, title:'Indirizzo', name:'dati.ShippingStreet', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.ShippingCity, title:'Città', name:'dati.ShippingCity', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.ShippingPostalcode, title:'Cap', name:'dati.ShippingPostalcode', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.ShippingState, title:'Provincia', name:'dati.ShippingState', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.Referente_Consegne__c, title:'Referente per consegne', name:'dati.Referente_Consegne__c', type:'text', placeholder:'', tabindex:itab++, disabled:  this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.Orari__c, title:'Orari e prenotazioni della destinazione', name:'dati.Orari__c', type:'text', placeholder:'', tabindex:itab++, disabled: this.readonly} );
      this.sections.push( { order: 5, title: 'Spedizione', opened: true, fields: sectionFields  });
      sectionFields=[];
      sectionFields.push( { id:itab++, value:this.dati.Tipologia__c, title:'Tipologia', name:'dati.Tipologia__c', type:'text', placeholder:'', tabindex:itab++, disabled: this.readonly} );
      sectionFields.push( { id:itab++, value:this.dati.Ubicazione__c, title:'Ubicazione', name:'dati.Ubicazione__c', type:'picklist', 
      options:[ 
        {label:'Centrale', value:'Centrale'},
        {label:'Periferica', value:'Periferica'},
        {label:'Centro commerciale', value:'Centro commerciale'},
        {label:'Turistica', value:'Turistica'},
      ], placeholder:'', tabindex:itab++, disabled: this.readonly} );
      sectionFields.push( { id:itab++, value:this.dati.Contratto__c, title:'Cliente a contratto', name:'dati.Contratto__c', type:'text', placeholder:'', tabindex:itab++, disabled: !this.newcustomer || this.readonly } );
      sectionFields.push( { id:itab++, value:this.dati.Competitors__c, title:'Competitors', name:'dati.Competitors__c', type:'text', placeholder:'', tabindex:itab++, disabled: this.readonly} );
      sectionFields.push( { id:itab++, value:this.dati.Description, title:'Note', name:'dati.Description', type:'textarea', placeholder:'', tabindex:itab++, disabled: this.readonly} );
      this.sections.push( { order: 6, title: 'Dati qualitativi', opened: true, fields: sectionFields  });
      sectionFields=[];

  },
  methods: {
    setField: function(e) {
      console.log(e)

      var s=this.sections[e.section];
      var f=s.fields[e.field];
      var v=e.value;

      var n=f.name;
      f.value=v;

      var n2=n.substr(n.indexOf(".")+1)
      console.log(n2)
      this.dati[n2]=v;
    },
    toggleSection: function(index) {
        this.sections[index].opened=!this.sections[index].opened;
    },
    nextPage: function() {
        this.page++;
    },
    prevPage: function() {
        this.page--;
    },
  }
}
</script>

<style scoped>

</style>
